import type { ArticleImage } from '@rankhelm/shared';

interface ArticleImagesTabProps {
  images: ArticleImage[];
  resolveImageUrl: (url: string | null | undefined) => string | null;
  onSelectImage: (imageId: string) => void;
}

export function ArticleImagesTab({ images, resolveImageUrl, onSelectImage }: ArticleImagesTabProps) {
  return (
    <div className="bg-slate-800 rounded-[10px] p-6 border border-slate-700">
      <h3 className="text-slate-100 mt-0 mb-4">
        Featured Image Options ({images.length})
      </h3>
      {images.length === 0 ? (
        <p className="text-slate-500 text-center p-8">
          No images generated yet. Images are generated automatically after article content.
        </p>
      ) : (
        <div className="grid grid-cols-2 gap-4">
          {images.map(img => (
            <div
              key={img.id}
              className={`rounded-[10px] overflow-hidden relative cursor-pointer transition-colors duration-200 ${
                img.is_selected ? 'border-[3px] border-blue-500' : 'border border-slate-700 hover:border-slate-500'
              }`}
              onClick={() => onSelectImage(img.id)}
            >
              <img
                src={resolveImageUrl(img.r2_key || img.image_url) || ''}
                alt={`Generated by ${img.model}`}
                className="w-full h-[200px] object-cover"
                onError={(e) => {
                  (e.target as HTMLImageElement).src =
                    'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="400" height="200"><rect fill="%23334155" width="400" height="200"/><text fill="%2394a3b8" x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="14">Image unavailable</text></svg>';
                }}
              />
              <div className="px-3 py-2 bg-slate-900">
                <div className="flex justify-between items-center">
                  <span className="text-slate-400 text-xs uppercase">
                    {img.model}
                  </span>
                  {img.is_selected && (
                    <span className="text-blue-500 text-xs font-semibold">
                      Selected
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
